import axios from "axios";
import { notificationsSlice, callTypes } from "./notificationsSlice";

const API_URL = process.env.REACT_APP_API_URL;
const { actions } = notificationsSlice;

export const fetchNotifications = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "/bespoke-notifications", { params: {
      _sort: 'created_at:DESC'
    }})
    .then((response) =>
    {  
      const notificationsBespoke =  response.data.map(notification => {
      let notificationType;
      if( notification.post){
        notificationType = 'Post'; 
      }else if(notification.article){
        notificationType = "Resource";
      }else{
        notificationType = 'None';
      } 
      
      return { ...notification, type: notificationType, categoryName: notification.category?.name ? notification.category.name  : 'All'   }}
      )

      dispatch(
        actions.notificationsFetched({ notificationsList: notificationsBespoke})
      )
    }
    )
    .catch((err) =>
      dispatch(actions.catchError({ error: err, callType: callTypes.list }))
    );
};

export const fetchCategories = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "categories")
    .then((response) => {
      dispatch(actions.categoriesFetched({ categoriesList: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};


export const searchArticles = (text) => (dispatch) => {
  return axios
  .get(API_URL + "/articles/search", {params: { _start: 0, _limit: -1, text }})
  .then((response) => {
    dispatch(actions.articlesFetched({ articlesSearch: response.data.articles }));
  })
  .catch((err) => {
    dispatch(actions.catchError({ error: err, callType: callTypes.list }));
  });

}

export const searchPost = (text) => (dispatch) => {
  return axios
  .get(API_URL + "/posts/search", {params: { _start: 0, _limit: -1 , text }})
  .then((response) => {
    dispatch(actions.postFetched({ postSearch: response.data.posts }));
  })
  .catch((err) => {
    dispatch(actions.catchError({ error: err, callType: callTypes.list }));
  });

}

export const cleanStateNotifications = (dispatch) => {
  dispatch(actions.postFetched({ postSearch: [] }));
  dispatch(actions.articlesFetched({ articlesSearch: [] }));
}

export const cleanVariables = (dispatch) => {
  dispatch(actions.postFetched({ postSearch: [] }));
  dispatch(actions.articlesFetched({ articlesSearch: [] }));
  dispatch(actions.catchError({ error: null, callType: callTypes.list }));
  dispatch(actions.notificationsCreated({ notificationsCreated: null }));
}

export const cleanError = (dispatch) => {
  dispatch(actions.catchError({ error: null, callType: callTypes.list }));
}

export const createBespokeNotification = (notificationData) => (dispatch) => {
  return axios
  .post(API_URL + "/bespoke-notifications", { 
    body: notificationData.body, 
    categoryId: notificationData.category ,
     articleId : notificationData.article , 
     postId: notificationData.post,
     creator_restless_user: notificationData.creator_restless_user
  })
  .then((response) => {
    dispatch(actions.notificationsCreated({ notificationsCreated: response.data }));
  })
  .catch((err) => {
    dispatch(actions.catchError({ error: err, callType: callTypes.list }));
  });

}